import { type IconType } from '@/defs/icon'
import { type LabelType } from '@/defs/misc'
import { type RecType } from '@/defs/rec'

export const ARTICLE_REPORT_CATEGORIES = [
  'cardLink',
  'cardEmbed',
  'deckEmbed',
  'mana',
  'footnote',
  'wpEmbed',
  'csbEmbed',
  'polldaddy',
  'scriptSrc',
  'scriptInline',
  'scriptEmpty',
] as const
export type ArticleReportCategoriesType = (typeof ARTICLE_REPORT_CATEGORIES)[number]
export const ARTICLE_REPORT_CATEGORY_LABELS: LabelType<ArticleReportCategoriesType> = {
  cardEmbed: { label: 'Card Embed' },
  cardLink: { label: 'Card Link' },
  csbEmbed: { label: 'Commander Spellbook Embed' },
  deckEmbed: { label: 'Deck Embed' },
  footnote: { label: 'Footnote' },
  mana: { label: 'Mana' },
  polldaddy: { label: 'Polldaddy Embed' },
  scriptEmpty: { label: 'Script Empty Embed' },
  scriptInline: { label: 'Script Inline Embed' },
  scriptSrc: { label: 'Script SRC Embed' },
  wpEmbed: { label: 'WordPress Embed' },
}

export const ARTICLE_REPORT_STATUSES = [
  'embedError',
  'cardLoadError',
  'cardLoading',
  'unknown',
  'embedSuccess',
  'cardLoadSuccess',
] as const
export type ArticleReportStatusType = (typeof ARTICLE_REPORT_STATUSES)[number]
export const ARTICLE_REPORT_STATUS_LABELS: LabelType<
  ArticleReportStatusType,
  {
    colorScheme: 'alert' | 'warning' | 'muted' | 'success'
    icon: IconType
    label: string
    labelPlural: string
  }
> = {
  cardLoadError: {
    colorScheme: 'warning',
    icon: 'circleXmark',
    label: 'Card Load Error',
    labelPlural: 'Card Load Errors',
  },
  cardLoading: { colorScheme: 'muted', icon: 'spinner', label: 'Card Still Loading', labelPlural: 'Loading Cards' },
  cardLoadSuccess: {
    colorScheme: 'success',
    icon: 'cards',
    label: 'Card Loaded Successfully',
    labelPlural: 'Card Loads',
  },
  embedError: { colorScheme: 'warning', icon: 'circleXmark', label: 'Embed Error', labelPlural: 'Embed Errors' },
  embedSuccess: { colorScheme: 'success', icon: 'check', label: 'Embed', labelPlural: 'Embeds' },
  unknown: { colorScheme: 'alert', icon: 'circleXmark', label: 'Unknown Error', labelPlural: 'Unknown Errors' },
}

export type ArticleReportType = {
  category: ArticleReportCategoriesType
  message?: string
  rec?: RecType
  status: ArticleReportStatusType
  subject?: string
}
